import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Text from 'v3/components/Text';

export default function Observation({ label, value }) {
  return (
    <Row>
      <Col md={12}>
        <Text type="medium" weight={500}>
          {label}
        </Text>
        <Text type="medium" color="dark" as="p" weight={500}>
          {value || 'Não informado'}
        </Text>
      </Col>
    </Row>
  );
}
